(function () {
  if (window.SMSMArabicBuyNowTextFixed) return;
  window.SMSMArabicBuyNowTextFixed = true;

  function isArabicPage() {
    return (
      document.documentElement.lang.toLowerCase().startsWith('ar') ||
      document.documentElement.dir === 'rtl' ||
      document.body.classList.contains('rtl')
    );
  }

  function smsmFixArabicBuyNowText() {
    if (!isArabicPage()) return;

    document.querySelectorAll(
      'shopify-buy-it-now-button button, .shopify-payment-button__button--unbranded, .shopify-payment-button button'
    ).forEach(function (btn) {
      var text = btn.textContent.trim();

      if (
        text === 'اشتر الآن' ||
        text === 'اشترِ الآن' ||
        text === 'Buy it now' ||
        text === 'اشتري الآن'
      ) {
        btn.textContent = 'اشتري الان';
        btn.setAttribute('aria-label', 'اشتري الان');
      }
    });
  }

  smsmFixArabicBuyNowText();

  document.addEventListener('DOMContentLoaded', smsmFixArabicBuyNowText);
  document.addEventListener('shopify:section:load', smsmFixArabicBuyNowText);

  setTimeout(smsmFixArabicBuyNowText, 500);
  setTimeout(smsmFixArabicBuyNowText, 1200);
  setTimeout(smsmFixArabicBuyNowText, 2500);

  var observer = new MutationObserver(function () {
    smsmFixArabicBuyNowText();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributeFilter: ['class']  // بدل ما يراقب كل حاجة، يراقب بس تغيير الـ class
  });
})();